import type { DtoOrderOrderTypeEnum } from '@repo/api-types/order-retrieval';
import type { AssetType } from '@repo/types/asset';

import { getAppConfig } from '@/utils/window.utils';

import { isFeatureEnabled } from './feature';

interface PaymentDateFeatureContext {
    assetType?: AssetType | undefined;
    orderType?: DtoOrderOrderTypeEnum | undefined;
    assetStatus?: string | undefined;
    permissions?: string[] | undefined;
}

export const isPaymentDateReadEnabled = (context: PaymentDateFeatureContext): boolean => {
    return isFeatureEnabled(getAppConfig().feature.paymentDateModification?.read, context);
};

export const isPaymentDateEditEnabled = (context: PaymentDateFeatureContext): boolean => {
    return isFeatureEnabled(getAppConfig().feature.paymentDateModification?.edit, context);
};
